export default function () {
  const widgetName = 'instaGridWidget';
  const widgetOpts = instaGridWidgetOpts;

  let windowSize = $(window).width();

  function removeLink(data, x, item) {
    const widgetData = data.items[x];
    const links = widgetData.URL;
    if (links === null) {
      $(item).removeAttr('href');
      $(item).removeAttr('target');
    }
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      // arguments: data, owl, hasData
      $(`#${widgetName} .card-widget-item`).each(function (x, item) {
        $(this).attr('target', '_blank');
        removeLink(data, x, item);
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: windowSize < 800 ? 6 : 12,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,
  });
}
